module.exports = __webpack_public_path__ + "img/google.d4b25177.svg";